import { useEffect } from "react";

export default function LiveChatWidget() {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://app.livechatai.com/embed.js";
        script.async = true;
        script.setAttribute(
            "data-id",
            "cmietv5my0001lb04ssnmozfh"
        );
        script.async = true
        script.defer = true

        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return null;
}